import globals from '../globals'; 

export const getHeaders = (includeToken = false, isMultipart = false) => {
  const headers = {};

  if (!isMultipart) {
    headers['Content-Type'] = 'application/json';
  }

  const businessId = localStorage.getItem('business_id');
  if (businessId) {
    headers['businessId'] = businessId;
  }

  if (includeToken) {
    const token = localStorage.getItem('authToken');
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  if (includeToken && businessId) {
    headers['Business-Id'] = businessId;
  }
  return headers;
};

// Get All Products
export const getAllProducts = async () => {
  const link = globals.baseUrl + '/get-all-products';
  const response = await fetch(link, {
    method: 'GET',
    headers: getHeaders(true),
  });
  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || 'Failed to fetch stores');
  }
  return response.json();
};

//Delete Product
export const deleteProduct = async (id) => {
  const link = globals.baseUrl + `/delete-product/${id}`;
  const response = await fetch(link, {
    method: 'POST',
    headers: getHeaders(true),
  });
  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || 'Failed to delete store');
  }
  return response;
};